module.exports = __webpack_public_path__ + "static/img/career-course-image5.ab202d16.png";